<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <table class="cell shrink" *ngFor="let wine of study.menuDecision.wines | keyvalue">
        <thead>
        <tr class="_titlePartTable">
            <th>{{'menu.' + wine.key | translate}}</th>
            <th class="_numberColumn"[i18nKey]="'common.quantity'"></th>
            <th class="_numberColumn"[i18nKey]="'study.wineStocks.price'"></th>
            <th class="_numberColumn"[i18nKey]="'common.total'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'study.wineStocks.initial.stock'"></td>
            <td class="_number">{{wine.value.initialStock}}</td>
            <td class="_number">{{wine.value.initialWacu | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{wine.value.initialWacu * wine.value.initialStock | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'study.wineStocks.purchases'"></td>
            <td class="_number">{{wine.value.purchasedNumber}}</td>
            <td class="_number">{{wine.value.purchasingPriceExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{wine.value.purchasedNumber * wine.value.purchasingPriceExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'study.wineStocks.stock.after.purchases'"></td>
            <td class="_totalColumn _number">{{wine.value.stock}}</td>
            <td class="_totalColumn _number">{{wine.value.wacu | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_totalColumn _number">{{wine.value.initialWacu * wine.value.initialStock + wine.value.purchasedNumber * wine.value.purchasingPriceExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'study.wineStocks.sales'"></td>
            <td class="_number">{{study.salesResult.winesSales[wine.key]}}</td>
            <td class="_number">{{wine.value.wacu | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number"></td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'study.wineStocks.final.stock'"></td>
            <td class="_totalColumn _number">{{study.salesResult.winesFinalStocks[wine.key]}}</td>
            <td class="_number"></td>
            <td class="_totalColumn _number">{{study.salesResult.winesFinalStocks[wine.key] * wine.value.wacu | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <div class="wine-variation">
        <span class="wine-variation-label"[i18nKey]="'study.wineStocks.variation'"></span>
        <div *ngFor="let wine of study.menuDecision.wines | keyvalue">
        <p class="wine-variation-label">{{'menu.' + wine.key | translate}}</p>
        <span class="wine-variation-value">{{study.financialResult.operatingCharges.cellarStockVariation.winesStockVariation[wine.key] | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></span>
        </div>
    </div>
</div>
